import axios from 'axios';

const instance = axios.create({
  method: 'get',
  responseType: 'json',
});

export default instance;



// WEBPACK FOOTER //
// ./node_modules/video-js-core/src/axios.js